<template>
  <v-select
    :items="workflowLibraryAssetList"
    item-value="id"
    item-text="name"
    v-model="idValue"
    label="Library Asset"
    :readonly="readonly"
    :rules="[requiredCheck()]"
    outlined
    dense
  ></v-select>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { required } from '@/lib/formValidations'

export default {
  props: [
    'id',
    'isRequired',
    'readonly'
  ],
  computed: {
    ...mapFields('workflowLibraryAssets', [
      'workflowLibraryAssetList'
    ]),
    idValue: {
      get () {
        return this.id
      },
      set (newValue) {
        this.$emit('assetIdChange', newValue)
      }
    }
  },
  methods: {
    ...mapActions('workflowLibraryAssets', [
      'getWorkflowLibraryAssets'
    ]),
    requiredCheck () {
      return !this.isRequired || required('Library Asset')
    }
  },
  created () {
    this.getWorkflowLibraryAssets({ isActive: true })
  }
}
</script>
